import * as React from "react";

import DocStyledTextEditor from "./StyledText/Editor";
import * as DocConvertRangeInlineJSON from "../../../helpers/Doc/Convert/RangeInlineJSON";
import * as DocConvertHTML from "../../../helpers/Doc/Convert/HTML";
import { isRangeInlineJSON } from "../../../helpers/Doc/Functions/RangeInlineJSON";
import { decodeHTMLEntities } from "../../../helpers/utils";

const renderContent = (content: InlineNode, onClick?: React.MouseEventHandler<HTMLSpanElement>, noSpan?: boolean) => {
  if (noSpan) {
    if (typeof content === "string") {
      return <>{decodeHTMLEntities(content.replace(/<[^>]+>/g, ''))}</>;
    } else if(isRangeInlineJSON(content)) {
      return <>{decodeHTMLEntities(DocConvertRangeInlineJSON.toHTML(content).replace(/<[^>]+>/g, ''))}</>;
    } else {
      return <>{decodeHTMLEntities(DocConvertHTML.fromInlineJson(content).replace(/<[^>]+>/g, ''))}</>;
    }
  } else {
    if (typeof content === "string") {
      return <span key={content} onClick={onClick} dangerouslySetInnerHTML={{__html: content}} />;
    } else if(isRangeInlineJSON(content)) {
      return <span key={content.text} onClick={onClick} dangerouslySetInnerHTML={{__html: DocConvertRangeInlineJSON.toHTML(content)}} />;
    } else {
      return <span onClick={onClick} dangerouslySetInnerHTML={{__html: DocConvertHTML.fromInlineJson(content)}} />;
    }
  }
};

interface DocStyledTextProps {
  noSpan?: boolean;
  uid?: string;
  content: InlineNode;
  contentKey?: string;

  disableStyleTextEditing?: boolean;

  editingContext: EditingContext;
  documentContext?: DocumentContext;

  independentlyEditable?: boolean;
  placeholder?: string;

  readOnly?: boolean;

  variantId?: number

  returnPlainText?: boolean; // Can drop?
};

export default function DocStyledText(props: DocStyledTextProps) {
  if (props.editingContext.isEditing && !props.readOnly) {
    return <DocStyledTextEditor {...props} />;
  } else {
    return renderContent(props.content, undefined, props.noSpan);
  }
}
